$(document).on('turbolinks:load', function () {
    const fileInput = $(".custom-file-input")
    fileInput.on("change", function() {
        var fileName = $(this).val().split("\\").pop();
        $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
    });
})